/**
 * Selector-based anti-flicker (contract §3.1).
 *
 * At early boot the runtime knows which experiments match the URL but not
 * yet which group the visitor is in. Instead of hiding the whole page, only
 * the elements a variant would touch are hidden (`visibility:hidden`) until
 * the decision is applied — or until the timeout, after which the page is
 * revealed no matter what (fail-open). `html`, `body` and `*` are never hidden.
 */
export const HIDE_ATTR = 'data-b2m-visual-hide';

const FORBIDDEN = /^(\*|html|body|:root)(\s*[,>\s]|$)/i;

export function hideSelectors({ doc, selectors, timeoutMs = 1200, nonce = '', logger = null } = {}) {
  const list = Array.from(new Set((selectors || []).map(s => String(s || '').trim()).filter(Boolean)))
    .filter(s => !FORBIDDEN.test(s))
    .filter(s => { try { doc.querySelector(s); return true; } catch (e) { return false; } });
  const handle = { revealed: false, timer: null, el: null, selectors: list, reveal() {} };
  if (!doc || list.length === 0) { handle.revealed = true; return handle; }

  const el = doc.createElement('style');
  el.setAttribute(HIDE_ATTR, '');
  if (nonce) el.setAttribute('nonce', nonce);
  el.textContent = `${list.join(',')}{visibility:hidden !important}`;
  (doc.head || doc.documentElement).appendChild(el);
  handle.el = el;

  handle.reveal = () => {
    if (handle.revealed) return;
    handle.revealed = true;
    if (handle.timer) { clearTimeout(handle.timer); handle.timer = null; }
    if (el.parentNode) el.parentNode.removeChild(el);
  };
  handle.timer = setTimeout(() => {
    if (!handle.revealed && logger) logger.log('[B2M Visual] anti-flicker timeout — revealing page');
    handle.reveal();
  }, Math.max(0, Number(timeoutMs) || 0));
  return handle;
}
